import { history } from "components/common/BrowserRouter"
import withHooks from "./withHooks"
import { AppColor } from "theme/app-color"
import { Box, Modal, MuiIcon, Typography } from "components"

const withConfirmGoBack = (outerProps) =>
  withHooks((props, hooks) => {
    const { useEffect, useCallback, useRef, useUrlParam } = hooks

    const queryParams = useUrlParam()

    const confirmInfo = useRef(
      {
        enabled: true,
      },
      [],
    )

    const enableConfirm = useCallback(() => {
      confirmInfo.current = {
        ...confirmInfo.current,
        enabled: true,
      }
    }, [])

    const disableConfirm = useCallback(() => {
      confirmInfo.current = {
        ...confirmInfo.current,
        enabled: false,
      }
    }, [])

    useEffect(() => {
      const unblock = history.block((location) => {
        const { enabled } = confirmInfo.current
        if (enabled) {
          Modal.confirm({
            title: "",
            children: (
              <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                <Box mb="16px">
                  <MuiIcon fontSize="large" color={AppColor["Error/Error Text"]} name="Warning"></MuiIcon>
                </Box>
                <Box mb="8px">
                  <Typography variant="h3" color={AppColor["Text/Primary Text"]}>
                    ต้องการออกจากหน้านี้หรือไม่
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body1" color={AppColor["Text/Primary Text"]}>
                    ข้อมูลทั้งหมดที่กรอกจะไม่ถูกบันทึก
                  </Typography>
                </Box>
                <Box mb="16px">
                  <Typography variant="body1" color={AppColor["Text/Primary Text"]}>
                    และไม่สามารถกู้คืนได้
                  </Typography>
                </Box>
              </Box>
            ),
            okButtonLabel: "ออกจากหน้านี้",
            okButtonVariant: "outlined",
            cancelButtonLabel: "ยกเลิก",
            cancelButtonVariant: "contained",
            buttonWidth: 147,
            swapButton: true,
            onOk: async ({ close }) => {
              if (outerProps?.onOk) outerProps.onOk()
              await close()
              unblock()
              // history.push(location)
              const locationParams = {
                ...location,
                search: `?${new URLSearchParams(queryParams).toString()}`,
              }
              history.push(locationParams)
            },
          })
          return false
        }
      })

      return () => {
        unblock()
      }
    }, [queryParams])

    return { ...props, enableConfirm, disableConfirm }
  })

export default withConfirmGoBack
